import { render, staticRenderFns } from "./row_access.vue?vue&type=template&id=c1761264"
import script from "./row_access.vue?vue&type=script&lang=js"
export * from "./row_access.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports